<template>
  <Banner>
    <img src="../assets/img/banner-small.jpg" alt="contact-us" name="Contact Us" style="width: 100%;max-height: 650px;">
  </Banner>
  <div class="contact">
    <div class="contact-content">
      <div class="contact-type">
        <div class="enterprise-name">HUBEI RCH ENTERPRISE ELECTRONIC CO.,LTD</div>

        <ul class="nav">
          <li class="nav-item">
            <i class="iconfont icon-telephone2"/> Tel: 0086 (717) 6985355
          </li>
          <li class="nav-item">
            <i class="iconfont icon-dayinchuanzhen"/> Fax: 0086 (717) 6985355
          </li>
          <li class="nav-item">
            <i class="iconfont icon-mobile"/> Mob: 0086 13657179347
          </li>
          <li class="nav-item">
            <i class="iconfont icon-whatsapp"/> Whatsapp: 0086 13657179347
          </li>
          <li class="nav-item">
            <i class="iconfont icon-skype1"/>
            <nuxt-link to="Skype:rch.intl?chat" style="color: #222">
              Skype: rch.intl
            </nuxt-link>
          </li>
          <li class="nav-item">
            <i class="iconfont icon-email"/>
            <nuxt-link to="mailto:info@rchocean.com" style="color: #222">
              E-mail: info@rchocean.com
            </nuxt-link>
          </li>
          <li class="nav-item">
            <i class="iconfont icon-website"/>
            <nuxt-link to="http://www.rchocean.com" style="color: #222">
              Website:http://www.rchocean.com
            </nuxt-link>
          </li>
          <li class="nav-item">
            <i class="iconfont icon-address"/>
            Address: Floor 4, Building 5, No. 188 Huaxi Road, Yichang High-tech District 443000, Hubei Province, China.
          </li>
        </ul>
      </div>
      <div class="contact-picture">
        <!--<img src="https://cktrfidtag.com/wp-content/uploads/2021/08/1.jpg" alt="" width="650" height="450">-->
        <!--<img src="../assets/img/company.png" alt="" width="650" height="450">-->
      </div>
    </div>
    <div class="map">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3431.394146907835!2d111.19041507403806!3d30.67918458822128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3683841f6fa2856d%3A0xf75a6e78422c11d0!2sYichang%20Hi-Tech%20Zone%20Electronic%20Information%20Industrial%20Park!5e0!3m2!1sen!2s!4v1683812645638!5m2!1sen!2s" width="100%" height="600" style="border:1px solid #eee;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>

  </div>

</template>

<script setup lang="ts">
useHead({
  title: 'Contact Us',
  meta: [
    { name: 'description', content: 'Contact RCH,Welcome to contact us' }
  ]
})
</script>

<style lang="stylus" scoped>
.contact
  min-width 1280px
  max-width 1510px
  padding 50px
  margin 0 auto
  box-sizing border-box
  &-content
    display flex
    .contact-type
      flex 1
      padding 0 20px
      .enterprise-name
        font-size 20px
        font-weight 300
      .nav
        margin-top 30px
        &-item
          line-height 32px
          font-size 16px
          font-weight 300
          color #222
          &:hover, &:hover>a
            color #1e8bac!important
          .iconfont
            margin-right 10px
            font-size 20px
    .contact-picture
      flex 1
      height 450px
      background url("../assets/img/company.png") no-repeat
      background-size calc(100% + 10px) 450px
      background-position -10px 0
      img
        float right
  .map
    margin-top 30px

</style>
